const helpers = {
    ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
    },

    showAlert(type, message) {
        $('#ajax-alert').html(`
            <div
                class="alert alert-message alert-message-${type} alert-dismissible fade show border-top-0 border-right-0 border-bottom-0 rounded-0"
                role="alert"
            >
                <h4>${helpers.ucfirst(type)}</h4>

                ${message}

                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        `)
    },

    showHorseRegistrationAlert(element, type, messages) {
        let messageList = '<ul>'
        messages.forEach((message) => {
            messageList += `<li>${message}</li>`
        })
        messageList += '</ul>'

        $(`${element}`).html(`
            <div class="alert alert-${type} alert-dismissible fade show mb-0 border-0" role="alert">
                ${messageList}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        `)
    },

    showRegistrationAlert(element, type, message) {
        $(`${element}`).html(`
            <div class="alert alert-${type} alert-dismissible fade show mb-0 border-0 text-center" role="alert">
                ${message}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        `)
    },

    closeAlert() {
        $('#ajax-alert')
            .fadeTo(10000, 500)
            .slideUp(500, function() {
                $('#ajax-alert').alert('close')
            })
    },

    bidUpStartAlert(text) {
        let options = {
            distance: 150,
        }
        Metro.toast.create(
            `<h5>
                <span class='icon-bell'></span>
                ${Lang.get('javascript.auctions.bid_up_has_started')}
             </h5>`,
            null,
            6000,
            'toast-custom',
            options,
        )
    },
}

export default helpers
